import { describeSchedule } from '@1qa/shared';
import type { Trigger } from './types';

/** The browser's timezone (default for new schedules). */
export function browserTimezone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
  } catch {
    return 'UTC';
  }
}

/** IANA timezones for the picker (the browser's list, or a short fallback). */
export function timezoneOptions(): string[] {
  const fallback = ['UTC', 'Europe/London', 'Europe/Berlin', 'Asia/Kolkata', 'Asia/Singapore', 'America/New_York', 'America/Los_Angeles', 'Australia/Sydney'];
  try {
    const all = (Intl as unknown as { supportedValuesOf?: (k: string) => string[] }).supportedValuesOf?.('timeZone');
    const list = all && all.length ? all : fallback;
    return list.includes('UTC') ? list : ['UTC', ...list];
  } catch {
    return fallback;
  }
}

/** A date and time shown in a given timezone, e.g. "Sat 24 Oct, 02:00". */
export function formatInZone(date: Date | string, tz: string): string {
  return new Intl.DateTimeFormat(undefined, { timeZone: tz, weekday: 'short', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }).format(new Date(date));
}

/** One line about when a trigger runs. */
export function triggerWhen(t: Pick<Trigger, 'kind' | 'cron' | 'timezone'>): string {
  if (t.kind === 'WEBHOOK') return 'When its webhook URL is called';
  return t.cron ? `${describeSchedule(t.cron)} (${t.timezone ?? 'UTC'})` : 'No schedule';
}

/** The public URL a webhook is called on (same address people use to open 1QA). */
export function webhookUrl(triggerId: string, origin = window.location.origin): string {
  return `${origin}/api/v1/hooks/${triggerId}`;
}
